'use client'

import { Divider, ListHeader } from '@macarongfactory/web-ui'
import { useRef } from 'react'

import { type IMycleContentSeriesItem } from '../model'
import StoryCardSwiper, { type IStoryCardItem } from './StoryCardSwiper'
import { carStoryTracking } from '../lib/tracking'
import useTrackOnVisible from '../model/useTrackOnVisible'

interface IMechanicStoriesSectionProps {
  items: IMycleContentSeriesItem[]
}

const MechanicStoriesSection = ({ items }: IMechanicStoriesSectionProps) => {
  const sectionRef = useRef<HTMLElement | null>(null)
  useTrackOnVisible({
    ref: sectionRef,
    tracker: carStoryTracking.showMechanicSection,
    enabled: items.length > 0,
  })

  if (items.length === 0) return null

  const cards: IStoryCardItem[] = items.map(item => ({
    id: item.serverId,
    imageUrl: item.thumbnailUrl,
    title: item.title,
    subtitle: item.series.mechanicInfo ?? '',
  }))

  return (
    <>
      <Divider.Horizontal strokeWidth='stroke-width-x10' />
      <section ref={sectionRef} className='pt-dimension-x3 pb-dimension-x10'>
        <ListHeader
          title={
            <ListHeader.Main.Title.Text
              text='마이클 정비사 이야기'
              typography='heading-3-bold'
            />
          }
        />
        <StoryCardSwiper
          items={cards}
          emphasis='title'
          onCardShow={(item, index) =>
            carStoryTracking.showMechanicCard(item.title, index)
          }
          onCardClick={(item, index) =>
            carStoryTracking.clickMechanicCard(item.title, index)
          }
          onFirstSwipe={carStoryTracking.scrollMechanic}
        />
      </section>
    </>
  )
}

export default MechanicStoriesSection
